module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.freight && _vm.$props.freight.id) ? _c('div', {
    staticClass: "z-freight-view"
  }, [_c('div', {
    staticClass: "z-freight-title"
  }, [_vm._v("Основные характеристики")]), _c('div', {
    staticClass: "z-freight__value-container"
  }, [_c('div', {
    staticClass: "z-freight__value w-40"
  }, [_c('div', {
    staticClass: "z-freight__value-label"
  }, [_vm._v("Количество мест:")]), _c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v(_vm._s(_vm.$props.freight.seats_number))])]), _c('div', {
    staticClass: "z-freight__value w-30"
  }, [_c('div', {
    staticClass: "z-freight__value-label"
  }, [_vm._v("Вес (кг):")]), _c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v(_vm._s(_vm.$props.freight.weight))])]), _c('div', {
    staticClass: "z-freight__value w-30"
  }, [_vm._m(0), _c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v(_vm._s(_vm.$props.freight.size))])]), _vm._m(1), (parseInt(_vm.$props.freight.doom) > 0) ? _c('div', {
    staticClass: "z-freight__value w-33"
  }, [_c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v("Обрешётка")])]) : _vm._e(), (parseInt(_vm.$props.freight.oversize) > 0) ? _c('div', {
    staticClass: "z-freight__value w-33"
  }, [_c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v("Негабаритный груз")])]) : _vm._e()]), (_vm.servicesServices && _vm.servicesServices.length) ? _c('div', {
    staticClass: "z-freight-title"
  }, [_vm._v("Дополнительные услуги")]) : _vm._e(), _c('div', {
    staticClass: "z-freight__value-container"
  }, _vm._l((_vm.servicesServices), function(item) {
    return _c('div', {
      staticClass: "z-freight__value"
    }, [(item.label) ? _c('div', {
      staticClass: "z-freight__value-label"
    }, [_vm._v(_vm._s(item.label + ': '))]) : _vm._e(), _c('div', {
      staticClass: "z-freight__value-value"
    }, [_vm._v(_vm._s(item.value))])])
  })), (_vm.servicesPackage && _vm.servicesPackage.length) ? _c('div', {
    staticClass: "z-freight-title"
  }, [_vm._v("Тара и упаковка")]) : _vm._e(), _c('div', {
    staticClass: "z-freight__value-container"
  }, _vm._l((_vm.servicesPackage), function(item) {
    return _c('div', {
      staticClass: "z-freight__value"
    }, [(item.label) ? _c('div', {
      staticClass: "z-freight__value-label"
    }, [_vm._v(_vm._s(item.label + ': '))]) : _vm._e(), _c('div', {
      staticClass: "z-freight__value-value"
    }, [_vm._v(_vm._s(item.value))])])
  }))]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-freight__value-label"
  }, [_c('span', [_vm._v("Объём м")]), _c('sup', [_vm._v("3")]), _c('span', [_vm._v(":")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-freight__value w-33"
  }, [_c('div', {
    staticClass: "z-freight__value-value"
  }, [_vm._v("Оформление ТТН")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1737f0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZFreightView.vue
// module id = 1115
// module chunks = 0